import { useEffect } from 'react';

export default function Modal({ open, onClose, title, children, footer, wide }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) {
      if (e.key === 'Escape') onClose?.();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-ink-950/60 p-4">
      <div
        className={
          'card w-full ' +
          (wide ? 'max-w-2xl' : 'max-w-md') +
          ' animate-in'
        }
      >
        <div className="flex items-center justify-between border-b border-ink-200 px-6 py-4 dark:border-ink-800">
          <h2 className="text-base font-semibold">{title}</h2>
          <button onClick={onClose} className="btn-ghost h-8 w-8 p-0">×</button>
        </div>
        <div className="px-6 py-5">{children}</div>
        {footer && (
          <div className="flex items-center justify-end gap-2 border-t border-ink-200 px-6 py-3 dark:border-ink-800">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
